import { SaleDetail, SaleFormValues } from "../../../types/sale";

export const mapCreditFiscal = (data: SaleDetail): SaleFormValues => ({
  id: data.id,
  correlativeId: data?.correlativeId, 
  documentNumber: data.documentNumber,
  saleDate: data.saleDate,
  branch: data.branch,
  customer: data.customer,
  documentType: data.documentType,
  paymentMethod: data.paymentMethod,
  globalDiscountPercentage: data.globalDiscountPercentage || 0,
  globalDiscountTarget: data.globalDiscountTarget || 'PRODUCTS',
  tipChargeRequested: data.tipChargeRequested ?? null,
  paymentCondition: data.paymentCondition,
  comments: data.comments,
  products: data.creditFiscalDetails?.products || [],
  totals: data.creditFiscalDetails?.totals || {},
  totalsView: data.creditFiscalDetails?.totalsView || {},
});
